<div class="inner-container" [class.is-nav-expanded]="navExpanded()">
	<div class="navigation-area">
		<a [routerLink]="['/']" (click)="$event.stopPropagation()">
			<img src="assets/images/logo.svg" alt="My LanguageBird" />
			<md-header size="xs" variant="regular">LanguageBird<span>&copy;</span></md-header>
		</a>

		<lb-navigation [navigationItems]="navigationItems()" [expanded]="navExpanded()" [disabled]="navDisabled()" (expandToggled)="toggleNav()">
		</lb-navigation>
	</div>

	<div class="page-content-area">
		<div class="page-banner">
			<lb-page-banner></lb-page-banner>
		</div>

		<div class="page-content-row">
			<div class="page-content" [ngClass]="{ 'sticky-option': stickyOpt() }">
				<ng-content></ng-content>
			</div>
			<lb-chat-slideout />
		</div>
	</div>
</div>
